import React from "react";
import { Box, Image, Text, Link } from "@chakra-ui/react";
import BuyTicket from "../images/Background/BuyTicket.png";
import BuyTicketMono from "../images/Background/BuyTicketMono.png";

interface CommonImageProps {
  onContextMenu: (e: { preventDefault: () => void }) => void;
  draggable: boolean;
}

const preventDefault = (e: { preventDefault: () => void }): void => {
  e.preventDefault();
};

const commonImageProps: CommonImageProps = {
  onContextMenu: preventDefault,
  draggable: false,
};

interface TicketButtonProps {
  text: string;
  color: string;
  isActive?: boolean;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
}

// チケットボタン用の共通スタイル
const ticketButtonStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mt: {
    base: 4,
    sm: 4,
    md: 6,
    lg: 6,
    xl: 8,
    "2xl": 8,
  },
  px: 8,
  py: 2,
};

// ボタンのコンテナスタイル
const buttonContainerStyles = {
  width: {
    base: "150px",
    sm: "180px",
    md: "250px",
    lg: "400px",
    xl: "400px",
  },
  position: "relative" as const,
  display: "inline-block",
  mx: "auto",
};

// チケットボタンのテキストスタイル
const ticketButtonTextStyles = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: {
    base: "10px",
    sm: "13px",
    md: "20px",
    lg: "33px",
    xl: "33px",
  },
  fontWeight: "bold",
  zIndex: 1,
  whiteSpace: "nowrap" as const,
  opacity: 1,
};

const TicketButton: React.FC<TicketButtonProps> = ({
  text,
  color,
  isActive = true,
  onClick,
  href,
  target,
  rel,
}) => {
  const ButtonContent = (
    <Box {...buttonContainerStyles}>
      <Image
        src={isActive ? BuyTicket : BuyTicketMono}
        alt="apply ticket"
        w="100%"
        h="auto"
        {...commonImageProps}
      />
      <Text {...ticketButtonTextStyles} color={color}>
        {text}
      </Text>
    </Box>
  );

  const hoverStyles = isActive ? { _hover: { opacity: 0.8 } } : {};

  return (
    <Box {...ticketButtonStyles}>
      {href ? (
        <Link
          href={href}
          target={target}
          rel={rel}
          onClick={onClick}
          {...hoverStyles}
          transition="opacity 0.2s"
          textDecoration="none"
          display="inline-block"
        >
          {ButtonContent}
        </Link>
      ) : (
        <Box
          onClick={onClick}
          {...hoverStyles}
          transition="opacity 0.2s"
          display="inline-block"
        >
          {ButtonContent}
        </Box>
      )}
    </Box>
  );
};

export default TicketButton;
